// extracted by mini-css-extract-plugin
export var root = "styles-module--root--jzqpi";